import React, { Component } from 'react';
import Relay from 'react-relay/classic';
import Radium, { Style } from 'radium';
import { SnackBarHelper } from '@lyearn-team/frontend-components';
import autobind from 'autobind-decorator';
import PropTypes from 'prop-types';

import { interactionsBlocked } from '../../../../helper/blockUserInteractionHelper';
import SubmissionHelper from './SubmissionHelper';
import AddQuestionSubmissionMutation from '../../../mutations/AddQuestionSubmissionMutation';
import ResubmitAssignmentMutation from '../../../mutations/ResubmitAssignmentMutation';
import PeerReview from '../PeerReview';
import PeerReviewView from './PeerReviewView';
import Popup from '../../../../popups/GlobalPopup';

@Radium
class AssignmentCard extends Component {
  constructor(props) {
    super(props);
    this.state.currentSubmission = !props.startsFromFirst ? this.getSubmissions().length - 1 : 0;
    // this.questionAnswers = [];
    this.questionAnswers = [];
    // console.log('this.questionAnswers:: ', this.questionAnswers);
  }

  static propTypes = {
    rootQ: PropTypes.object.isRequired,
    relay: PropTypes.object.isRequired,
    enrollPressed: PropTypes.func
  };

  static contextTypes = {
    showLoading: PropTypes.func,
    hideLoading: PropTypes.func,
    submissionOn: PropTypes.func
  };

  state = {
    showDailog: false
  };

  componentDidMount() {
    // console.log(this.context.submissionOn);
    this.context.submissionOn && this.context.submissionOn(true);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.rootQ.pid !== this.props.rootQ.pid) {
      this.questionAnswers = [];
      this.state.currentSubmission = !nextProps.startsFromFirst
        ? this.getSubmissions(nextProps.rootQ.questionAnswers).length - 1
        : 0;
    }
  }

  componentWillUnmount() {
    this.context.submissionOn && this.context.submissionOn(false);
  }

  postSubmission = (
    { isRemoved, answerArray, submisisonCallBacks, actualSubmit, cardId },
    doneCallback,
    callBack
  ) => {
    actualSubmit && this.context.showLoading();

    const mutation = new AddQuestionSubmissionMutation({
      rootOfferId: this.props.course && this.props.course.pid,
      userId: this.props.relay.variables.userId,
      cardId: cardId || this.props.rootQ.pid,
      answerArray,
      card: this.props.rootQ,
      mainId: this.props.rootQ.id,
      actualSubmit,
      courseGraphId: this.props.course && this.props.course.id,
      pathId: this.props.pathInfo && this.props.pathInfo.pid,
      pathGraphId: this.props.pathInfo && this.props.pathInfo.id,
      coursePerformanceId:
        this.props.course &&
        this.props.course.coursePerformance &&
        this.props.course.coursePerformance.id,
      userGraphId: this.props.userObj.id
    });

    mutation.commit({
      onSuccess: d => {
        /* this.props.lessonProgressChangeCallback(
          this.props.rootQ.pid,
          this.props.rootQ.performance && this.props.rootQ.performance.scaledProgressMeasure,
          this.props.rootQ
        ); */
        setTimeout(() => {
          actualSubmit && this.context.hideLoading();
        }, 2000);
        doneCallback && doneCallback();
        callBack && callBack();
        submisisonCallBacks &&
          submisisonCallBacks.length > 0 &&
          submisisonCallBacks.forEach(sc => sc && sc());
        if (isRemoved) {
          SnackBarHelper.showSnackbar({
            label: 'Your response has been removed.'
          });
        }
      },
      onFailure: t => {
        actualSubmit && this.context.hideLoading();
        callBack && callBack();
        SnackBarHelper.showSnackbar({
          label: 'Failed in submitting response...',
          status: 'error'
        });
        console.error('Failed at postResponse: ', t.getError());
      }
    });
  };

  @autobind
  changeResponseTypePressed(position, callback) {
    // this.setState({
    //   showDailog: true
    // });
    this.changeResponseTypePosition = position;
    this.changeResponseTypeCallback = callback;
  }

  renderSubmissionItem() {
    // console.log('fullScreen::', this.props.fullScreen);

    const submissions = this.getSubmissions();
    const successSubmit = this.audioSuccessSubmit;
    this.audioSuccessSubmit = false;
    return (
      <SubmissionHelper
        ref="submissionHelper"
        userId={this.props.relay.variables.userId}
        rootQForQuiz={this.props.rootQ}
        submissions={submissions}
        cardId={this.props.rootQ.pid}
        cardName={this.props.rootQ.name}
        card={this.props.rootQ}
        successSubmitAudio={successSubmit}
        changeResponseTypePressed={this.changeResponseTypePressed}
        showEnrollDialog={this.props.showEnrollDialog}
        isEnrolled={this.props.isEnrolled}
        getSubmissions={this.getSubmissions}
        cardArray={this.props.cardArray}
        cardArrayCurrentCardIndex={this.props.cardArrayCurrentCardIndex}
        toggleFullscreen={this.props.toggleFullscreen}
        fullScreen={this.props.fullScreen}
        postSubmission={this.postSubmission}
        actualSubmit={this.props.rootQ.performance && this.props.rootQ.performance.actualSubmit}
        resubmitClick={this.resubmitClick(true)}
        preview={!!this.props.preview}
        guestMode={!!this.props.guestMode}
        courseId={this.props.course.pid}
      />
    );
  }

  @autobind
  handleDialogClose(changePressed) {
    this.setState({
      showDailog: false
    });
    // console.log('on Change pressed', this.getSubmissions()[this.state.currentSubmission]);
    changePressed &&
      this.postSubmission({
        response: '',
        questionId: this.getSubmissions()[this.state.currentSubmission].questionId,
        logAnswer: true,
        isAudioResponse: false,
        callback: null,
        isRemoved: true,
        rawScore: this.getSubmissions()[this.state.currentSubmission].rawScore,
        progressMeasure: 0
      });
    changePressed && this.changeResponseTypeCallback && this.changeResponseTypeCallback();
  }

  resubmitClick = show => () => {
    this.setState({
      showResubmitDialog: show,
      resubmitData: show
        ? {
            rootOfferId: this.props.course.pid,
            assignmentCardId: this.props.rootQ.pid,
            userId: this.props.userId,
            timeStamp: this.props.timeStamp,
            courseRelayId: this.props.course.id,
            cardRelayId: this.props.rootQ.id
          }
        : null
    });
  };

  confirmResubmitClick = () => {
    if (interactionsBlocked()) {
      return false;
    }
    this.context.showLoading();
    const mutation = new ResubmitAssignmentMutation(
      {
        ...this.state.resubmitData
      },
      {
        onSuccess: s => {
          this.context.hideLoading();
          /* this.props.lessonProgressChangeCallback(
            this.props.rootQ.pid,
            this.props.rootQ.performance && this.props.rootQ.performance.scaledProgressMeasure,
            this.props.rootQ
          ); */
          this.refs.submissionHelper && this.refs.submissionHelper.clearAllSubmissions();
          // this.refs.submissionHelper && (this.refs.submissionHelper.makeSaveButtonVisible = false);
          this.setState({ showResubmitDialog: false });
          SnackBarHelper.showSnackbar({
            label: 'You can now resubmit the assignment',
            duration: 3
          });
          console.debug(s);
        },
        onFailure: t => {
          this.context.hideLoading();
          this.setState({ showResubmitDialog: false });
          const error = t.getError() || new Error('Mutation failed.');
          console.error(error);
          SnackBarHelper.showSnackbar({
            label: 'Error in resubmit, please try again.',
            status: 'error'
          });
        }
      }
    );
    mutation.commit();
  };

  renderResubmitButton = () => {
    const passScore =
      this.props.rootQ.minScaledScore * (this.props.rootQ.maxScore - this.props.rootQ.minScore) +
      this.props.rootQ.minScore;
    if (
      (this.props.rootQ.performance && this.props.rootQ.performance.successStatus === 'FAIL') ||
      !!window.showreadyToStartAgain
    ) {
      return (
        <div style={styles.resubmitWrapper}>
          <div>
            <div style={styles.readyToStart}>Ready to start again?</div>
            <div style={styles.requiredScore}>
              {`You need to score at least ${Math.ceil(passScore)}/${
                this.props.rootQ.maxScore
              } to pass`}
            </div>
          </div>
          <div style={styles.resubmitButton} onClick={this.resubmitClick(true)}>
            START AGAIN
          </div>
        </div>
      );
    }
    return null;
  };

  @autobind
  getSubmissions(newQuestions) {
    const submissions = [];
    const questions = newQuestions || this.props.rootQ.questionAnswers || [];
    for (let i = 0; i < questions.length; i++) {
      submissions.push({
        questionId: questions[i].pid,
        question: questions[i].q,
        rawScore: questions[i].rawScore,
        minScore: questions[i].minScore,
        maxScore: questions[i].maxScore,
        questionObj: questions[i],
        answer: questions[i].answer && questions[i].answer[0],
        answerType: questions[i].rType,
        answerTypeSecondary: questions[i].rTypeSecondary,
        options: questions[i].options,
        response: questions[i].answer && questions[i].answer[0] && questions[i].answer[0].response
        // response: questions[i].answer[0] && questions[i].answer[0].response
      });
      // console.log('qq', questions[i].answer[0] && questions[i].answer[0].response);
    }
    return submissions;
  }

  render() {
    // const actions = [
    //   <FlatButton
    //     label="Cancel"
    //     primary={true}
    //     keyboardFocused={true}
    //     onTouchTap={() => this.handleDialogClose(false)}
    //   />,
    //   <FlatButton
    //     label="Yes"
    //     primary={true}
    //     onTouchTap={() => this.handleDialogClose(true)}
    //   />,
    // ];

    return (
      <div style={styles.posRelative} className="assignmentCardContainer">
        {this.renderResubmitButton()}
        <div style={styles.container}>
          {this.renderSubmissionItem()}
          {/* <Dialog
            actions={actions}
            modal={true}
            open={this.state.showDailog}
            onRequestClose={() => this.handleDialogClose(false)}
          >
            Are you sure you want to change the response type? This will remove your previosly submitted answer.
          </Dialog> */}
          <Popup
            showPopup={this.state.showResubmitDialog}
            popUpInnerWrapper={styles.popUpInnerWrapper}
            hidePopup={this.resubmitClick(false)}
            showCloseButton={true}
            closeButtonStyle={styles.closeButtonStyle}
            mainWrapperStyle={styles.mainWrapperStyle}
          >
            <span style={styles.confirmationText}>
              Your submission will be permanently deleted and you will be prompted to re-record. Are
              you sure you want to continue deleting?
            </span>
            <div style={[styles.popUpActions, styles.displayFlexRow]}>
              <span
                key="yes"
                onClick={this.confirmResubmitClick}
                style={[styles.displayFlexRow, styles.alignItemsCenter, styles.confirmationButton]}
              >
                Yes
              </span>
              <span
                key="no"
                onClick={this.resubmitClick(false)}
                style={[styles.displayFlexRow, styles.alignItemsCenter, styles.confirmationButton]}
              >
                No
              </span>
            </div>
          </Popup>
        </div>
        {this.getSubmissions().length > 1 ? <div style={styles.bottomNavigation} /> : null}
        <Style rules={styles.classBased} scopeSelector=".assignmentCardContainer" />
      </div>
    );
  }
}

const styles = {
  classBased: {
    '.troubleLink': {
      padding: '12px',
      textAlign: 'right'
    },
    '.troubleLink a': {
      color: '#8492a6',
      fontSize: '14px',
      cursor: 'pointer'
    },
    '.troubleLink a:hover': {
      color: '#1f2d3d'
    }
  },
  container: {
    flex: 1,
    position: 'relative'
  },
  activeDot: {
    width: '11px',
    height: '11px',
    background: '#0ABFF1',
    border: '0px'
  },
  dot: {
    background: 'white',
    borderRadius: '50%',
    border: '1.5px solid #BBC2C8',
    width: '8px',
    height: '8px',
    display: 'inline-block',
    marginRight: '8px',
    cursor: 'pointer'
  },
  bottomNavigation: {
    textAlign: 'center',
    marginTop: '14px'
  },
  arrowStyle: {
    position: 'absolute',
    margin: 'auto',
    display: 'flex',
    alignItems: 'center',
    top: '0px',
    height: '100%'
  },
  arrowIconContainer: {
    cursor: 'pointer'
  },
  leftArrow: {
    left: '0px'
  },
  rightArrow: {
    right: '0'
  },
  iconTransparent: 'transparent',
  IconColor: 'rgba(139,145,151,0.56)',
  posRelative: {
    position: 'relative'
  },
  resubmitWrapper: {
    width: '85%',
    maxWidth: '680px',
    margin: '0 auto',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    padding: '0px 0px 23px'
  },
  readyToStart: {
    color: '#575766',
    fontSize: '20px',
    fontWeight: '500',
    padding: '0 0 4px 0',
    lineHeight: '1.2em'
  },
  requiredScore: {
    color: '#767e86',
    fontSize: '14px',
    fontWeight: '500'
  },
  resubmitButton: {
    cursor: 'pointer',
    fontWeight: 600,
    color: '#ffffff',
    padding: '13px 32.5px',
    background: '#0abff1',
    borderRadius: '4px',
    margin: '0 17px 0 0'
  },
  unAssignQuestion: {
    margin: '21px 0 30px',
    fontSize: '15px',
    lineHeight: '20px',
    fontWeight: '500',
    color: '#ffffff',
    borderRadius: '4px'
  },
  popUpInnerWrapper: {
    width: '450px',
    minHeight: '150px',
    padding: '20px 40px 20px 20px',
    position: 'relative'
  },
  closeButtonStyle: {
    width: '16px',
    height: '16px'
  },
  mainWrapperStyle: {
    cursor: 'default'
  },
  popUpActions: {
    position: 'absolute',
    right: '20px',
    bottom: '20px'
  },
  confirmationText: {
    fontSize: '15px',
    lineHeight: '20px',
    fontWeight: '500'
  },
  confirmationButton: {
    marginLeft: '20px',
    textTransform: 'uppercase',
    fontSize: '13px',
    lineHeight: '18px',
    background: '#00AAD9',
    color: 'white',
    justifyContent: 'center',
    padding: '3px 30px',
    borderRadius: '4px',
    cursor: 'pointer',
    height: '30px',
    letterSpacing: '0.6px',
    fontFamily: 'ProximaNova',
    ':hover': {
      boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.2)'
    }
  },
  displayFlexRow: {
    display: 'flex',
    flexDirection: 'row'
  },
  displayFlexColumn: {
    display: 'flex',
    flexDirection: 'column'
  },
  alignItemsCenter: {
    alignItems: 'center'
  }
};

export default Relay.createContainer(AssignmentCard, {
  initialVariables: {
    userId: null
  },
  fragments: {
    rootQ: variables => Relay.QL`
      fragment on Card {
        id
        pid
        name
        globalPosition
        contributeToSuccessStatus
        minScaledScore
        maxScore
        minScore
        reAttemptAllowed
        description
        performance(userId: $userId) {
          id
          successStatus
          actualSubmit
          completionStatus
          forceComplete
          progressMeasure
          scaledProgressMeasure
        }
        resource{
          type
        }
        questionAnswers(userId: $userId) {
          pid
          q
          rType
          rTypeSecondary
          rawScore
          minScore
          maxScore
          gradingScheme
          contributeToCompleteStatus
          actualSubmit
          peerQuestions(userId: $userId) {
            question
            reviewsReceived {
              reviewedBy {
                pid
              }
            }
          }
          opinionType
          options{
            text
            correct
          }
          topRatedResponses {
            answer {
              response
              answerType
            }
            user {
              name
              picture
            }
          }
          answer{
            id
            pid
            evaluatedAnswer
            response
            lastUpdatedResponse
            thumbUrl
            answerType
            feedback
            feedbacks {
              feedback
              feedbackGivenBy {
                pid
                actorType
              }
            }
            gradedBy {
              pid
            }
            feedbackGivenBy {
              pid
            }
          }
        }
        minReviewCount
        ${PeerReviewView.getFragment('rootQ', { userId: variables.userId })}
        ${PeerReview.getFragment('rootQ', { userId: variables.userId })}
      }
    `
  }
});
